import {} from './global'

const Themeroutes = global.rootRequire('themes/netalo/themeroutes').default
const routes = [].concat(Themeroutes)

export default routes
